import { createModalContext } from 'modules/campaigns/lib/contexts';

export enum AlertsModalType {
  UpdateAlertsModal = 'UpdateAlertsModal',
  AddWebhookModal = 'AddWebhookModal',
  EditWebhookModal = 'EditWebhookModal',
  DeleteWebhookModal = 'DeleteWebhookModal',
  DisplayWebhookJSONAttributes = 'DisplayWebhookJSONAttributes',
}

const ALERTS_MODAL_PROVIDER_DEBUG_NAME = 'AlertsModalProvider';

/**
 * TODO: make these types stricter
 */
export type ModalProps = Record<string, any>;

export const {
  ModalContext: AlertsModalContext,
  ModalProvider: AlertsModalProvider,
  useModalContext: useAlertsModalContext,
} = createModalContext<AlertsModalType, ModalProps>(ALERTS_MODAL_PROVIDER_DEBUG_NAME);
